import * as React from "react";
import Box from "@mui/material/Box";
import { Button, CircularProgress, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import BlogsCard from "./BlogsCard";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Link } from "react-router-dom";
import Divider from "@mui/material/Divider";

import { createTheme, ThemeProvider } from "@mui/material/styles";
const theme = createTheme();

theme.typography.h3 = {
  fontSize: "28px",
  "@media (min-width:600px)": {
    fontSize: "32px",
  },
};

const HomePageBlogs = () => {
  const [blogslist, setBlogsslist] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  React.useEffect(() => {
    fetch("https://tranquil-anchorage-09740.herokuapp.com/blogs")
      .then((response) => response.json())
      .then((json) => {
        setBlogsslist(json);
        setIsLoading(false);
      });
  }, []);
  return (
    <Box id="blogs">
      <ThemeProvider theme={theme}>
        <Typography
          gutterBottom
          variant="h3"
          component="div"
          sx={{ textAlign: "center", pt: 7, pb: 2 }}
        >
          BLOGS (fake blogs)
          <Divider variant="middle" />

        </Typography>

        {isLoading && <CircularProgress />}
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {blogslist.slice(0, 3).map((blog, index) => (
              <BlogsCard isLoading={isLoading} blog={blog} key={blog?._id}></BlogsCard>
            ))}
          </Grid>
        </Box>
        <Box sx={{ textAlign: "center", fontWeight: "bold", mt: 4 }}>
          <Link to="/allblogs">
            {" "}
            <Button className="button-beguni" variant="contained">
              <VisibilityIcon sx={{ m: 1 }} />
              View All Blogs
            </Button>
          </Link>
        </Box>
      </ThemeProvider>
    </Box>
  );
};

export default HomePageBlogs;
